function initFAQAccordion(container = document) {
  const questionHeaders = container.querySelectorAll(".accordion-item__button");
  let currentlyOpen = null;
 
  questionHeaders.forEach((el) => {
    el.addEventListener("click", () => {
      const content = el.nextElementSibling;
      const isHidden = content.classList.contains("visually-hidden");
     
 
      el.querySelector(".button__collapse-icon").classList.toggle("visually-hidden");
      el.querySelector(".button__expand-icon").classList.toggle("visually-hidden");
 
      if (isHidden && currentlyOpen && currentlyOpen !== content) {
        closeAccordionItem(currentlyOpen);
        currentlyOpen = content;
      } else {
        currentlyOpen = isHidden ? content : null;
      }
 
      if (isHidden) {
        openAccordionItem(content);
      } else {
        closeAccordionItem(content);
      }
    });
  });
 
  function openAccordionItem(content) {
    content.style.display = "block";
    content.style.height = "0";
    content.style.margin = "0";
   
    content.classList.remove("visually-hidden");
   
    void content.offsetHeight;
   
    const height = content.scrollHeight;
    content.style.height = height + "px";
    content.style.marginBottom = "1.25rem";
   
    content.addEventListener("transitionend", function onEnd(e) {
      if (e.propertyName === 'height') {
        content.style.height = "";
        content.removeEventListener("transitionend", onEnd);
      }
    }, {once: false});
  }
 
  function closeAccordionItem(content) {
    const openButton = content.previousElementSibling;
   
    const height = content.scrollHeight;
    content.style.height = height + "px";
   
    void content.offsetHeight;
   
    content.style.height = "0";
    content.style.marginBottom = "0";
   
    openButton.querySelector(".button__collapse-icon").classList.add("visually-hidden");
    openButton.querySelector(".button__expand-icon").classList.remove("visually-hidden");
   
    content.addEventListener("transitionend", function onEnd(e) {
      if (e.propertyName === 'height') {
        content.classList.add("visually-hidden");
        content.style.height = "";
        content.style.display = "none";
        content.removeEventListener("transitionend", onEnd);
      }
    }, {once: false});
  }
}
 
document.addEventListener("DOMContentLoaded", () => {
  initFAQAccordion();
});
document.addEventListener("shopify:section:load", (event) => {
  initFAQAccordion(event.target);
});